<template>
  <el-row
    :gutter="10"
    style="margin-bottom: 10px;"
  >
    <el-col>
      <el-button
        v-for="tab in tabs"
        :key="tab.value"
        :type="activeTab === tab.value ? 'primary' : 'default'"
        size="mini"
        @click="$emit('set-tab', tab.value)"
      >
        {{ tab.label }}
      </el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'XeroActionButtons',
  props: {
    active_tab: { type: String, required: true }
  },
  data() {
    return {
      tabs: [
        { value: 'invoices', label: 'Invoices' },
        { value: 'bills', label: 'Bills' },
        { value: 'payments', label: 'Payments' },
        { value: 'credit_notes', label: 'Credit Notes' }
      ]
    };
  }
};
</script>
